// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9000) return "static/chunks/9000-6bcf7f238ec30037.js";
	if (chunkId === 1814) return "static/chunks/1814-b7a421793e63328e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1445":"49b8c7ff31a853e8","5566":"47b856e2f9e706ae","7990":"393285a738dc5dc3","8230":"f32864728be4f26b","8606":"2483f4ac8aed6d74","8850":"6def8cbb38544d1c","9895":"654053ca92bdc4c6"}[chunkId] + ".js";
};